/**
 * 腾讯地图
 * @see http://lbs.qq.com/javascript_v2/index.html
 */
window.init = () => {
  console.log("map loaded"); // eslint-disable-line
};

const MAP_KEY = "7DUBZ-QMI33-2HB3H-37DMO-3TUMZ-JJBFS";

const MAP_SCRIPT_ID = "tmapScript";

const DEFAULT_OPTIONS = {
  zoom: 16,
  minZoom: 12,
  maxZoom: 18,
  scrollwheel: true,
  disableDoubleClickZoom: true,
  panControl: false,
  // zoomControl: false,
  mapTypeControl: false,
};

class MapAdapter {
  static genScript() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = MAP_SCRIPT_ID;
    script.charset = "utf-8";
    script.defer = true;
    script.async = true;
    // 腾讯地图异步加载一定要有callback参数
    script.src = `//map.qq.com/api/js?v=2.exp&key=${MAP_KEY}&callback=init`;
    return script;
  }

  static genLatLng({ lat, lng }) {
    return new qq.maps.LatLng(lat, lng);
  }

  static genPosition(latLng) {
    return { lat: latLng.getLat(), lng: latLng.getLng() };
  }

  constructor(options) {
    this.mapId = `J-TMapDom_${Math.random()
      .toString(36)
      .slice(2)}`;
    this.draggable = options.draggable;
    this.onMarkerChange = options.onMarkerChange;
    this.onLoaded = options.onLoaded;
    this.options = options.options || {};
  }

  // 通过坐标获取地址
  getAddress({ lng, lat }) {
    const geocoder = new qq.maps.Geocoder({
      complete: result => {
        const { province, city, district } = result.detail.addressComponents;
        this.onMarkerChange({ lng, lat }, { province, city, district });
      },
    });
    geocoder.getAddress(MapAdapter.genLatLng({ lng, lat }));
  }

  // inner
  setIcon() {
    const markerIcon = new qq.maps.MarkerImage(require("./location.png"));
    this.marker.setIcon(markerIcon);
  }

  // 实例化点标记
  initMarker({ lng, lat }) {
    const latLng = MapAdapter.genLatLng({ lng, lat });
    this.initTMarker(latLng);
  }

  initTMarker(latLng) {
    this.marker = new qq.maps.Marker({
      position: latLng,
      map: this.map,
      draggable: this.draggable,
    });
    this.setIcon();
    if (this.draggable) {
      qq.maps.event.addListener(this.marker, "mouseup", () => {
        this.setTMapPos(this.marker.getPosition(), false);
      });
      const that = this;
      qq.maps.event.addListener(this.map, "click", function(e) {
        // eslint-disable-line
        that.setTMapPos(e.latLng);
      });
    }
  }

  // 设置标记位置
  setPos({ lng, lat }, positionChanged = true) {
    const latLng = MapAdapter.genLatLng({ lat, lng });
    this.setTMapPos(latLng, positionChanged);
  }

  // inner
  setTMapPos(latLng, positionChanged = true) {
    if (positionChanged) {
      if (!this.marker) {
        this.initTMarker(latLng);
      } else {
        this.marker.setPosition(latLng);
      }
    }
    // 将标记置于地图中心
    // 需要 setTimeout 让标记先移动
    setTimeout(() => {
      this.map && this.map.setCenter(latLng);
    }, 1000);
    this.getAddress(MapAdapter.genPosition(latLng));
  }

  setCenterAndPos(latLng) {
    this.map && this.map.setCenter(latLng); // 必须先让点置于可视范围，否则 marker 出不来
    this.setTMapPos(latLng);
  }

  // inner
  searchByKeyword(city, keyword) {
    const searchService = new qq.maps.SearchService({
      location: city,
      complete: result => {
        if (result.detail.pois && result.detail.pois.length > 0) {
          this.setCenterAndPos(result.detail.pois[0].latLng);
        }
      },
    });
    // 切换城市时自动定位到城市并设置中心标记
    searchService.search(keyword);
  }

  // 设置城市
  setCity(city) {
    if (!this.cityService) {
      this.cityService = new qq.maps.CityService({
        complete: result => {
          this.setCenterAndPos(result.detail.latLng);
        },
      });
    }
    if (!city) {
      // 获取城市列表接口设置中心点
      this.cityService.searchLocalCity();
    } else if (this.city !== city) {
      this.cityService.searchCityByName(city);
    }
  }

  // 设置区
  setDistrict(city, district) {
    this.searchByKeyword(city, district);
  }

  // 根据位置搜索
  setAddress(addr) {
    if (!addr) return;
    if (!addr.street && !addr.block) return;
    const key = `${addr.district}${addr.street}${addr.block}`.trim();
    if (key.length <= 2) return;
    this.searchByKeyword(addr.city, key);
  }

  // 加载地图
  load({ lng, lat, city, district }) {
    if (document.getElementById(MAP_SCRIPT_ID)) {
      this.init({ lng, lat, city, district });
      return;
    }
    const script = MapAdapter.genScript();
    script.onload = () => {
      const timer = setInterval(() => {
        this.init({ lng, lat, city, district }, timer);
      }, 100);
    };
    document.body.appendChild(script);
  }

  // 渲染地图
  init({ lng, lat, city, district }, timer) {
    if (typeof window.qq === "undefined") return;
    /* global qq */
    if (typeof qq.maps.Map !== "function") return;
    clearInterval(timer);
    // 已知坐标直接设置坐标为中心点
    // 未知坐标，默认定位到中心点
    this.map = new qq.maps.Map(document.getElementById(this.mapId), Object.assign({}, DEFAULT_OPTIONS, this.options));
    this.onLoaded();
    if (lng && lat) {
      this.setCenterAndPos(MapAdapter.genLatLng({ lng, lat }));
    } else if (district) {
      // 如果设置了城市，则定义到该城市
      this.setDistrict(city, district);
    } else {
      // 获取城市列表接口设置中心点
      this.setCity();
    }
  }

  destroy() {
    if (this.map && this.map.destroy) {
      this.map.destroy();
    }
    this.map = undefined;
  }
}

export default MapAdapter;

require("./index.less");